pageId = 'page-member-settings_complete_account'
page = '#' + pageId

$ ->
  $(document).on 'ajax:success', "#{ page } .form-settings-complete-account", (e, result) ->
    if result.success
      simple.dialog.message content: result.msg
      setTimeout ->
        if result.need_signin
          location.href = result.url
        else
          tower.stack.load result.url,
            root: true
      , 2000
